export class TreeViewNode {
    constructor(label, text, children) {
        this.label = label;
        this.text = text;
        this.children = children;
    }
    get treeViewNodeLabel() {
        return this.label;
    }
    get treeViewNodeText() {
        return this.text;
    }
    get treeViewNodeChildren() {
        return this.children;
    }
}
